import { SHARED_AUTHORITY, SHARED_SSO } from './environment.shared';

export const environment = {
	production: false,
	enableServiceWorker: false,
	apiUrl: 'https://dev.gtlcapi.ca/rest/gtlc-cms_dev',
	redirectUrl: 'https://dev.staff.gtlc.ca',
	uploadUrl: 'https://dev.gtlcapi.ca/uploads',
	msal: {
		clientId: SHARED_SSO.msal.clientId,
		authority: SHARED_AUTHORITY,
		redirectUri: 'https://dev.staff.gtlc.ca',
	},
	wsServer: 'wss://dev.gtlcapi.ca/ws/websocket',
};
